import { render, staticRenderFns } from "./LogBookIndoorSmallFigures.vue?vue&type=template&id=4cac43d0"
import script from "./LogBookIndoorSmallFigures.vue?vue&type=script&lang=js"
export * from "./LogBookIndoorSmallFigures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports